
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M11.733 0H4.267C1.543 0 0 1.543 0 4.267v7.466C0 14.45 1.536 16 4.267 16h7.466C14.457 16 16 14.45 16 11.733V4.267C16 1.543 14.457 0 11.733 0z","fill":"#fff"}}),_c('path',{attrs:{"d":"M10.656 8.566H8.6v2.04a.597.597 0 01-.6.594.597.597 0 01-.599-.595V8.566H5.343A.603.603 0 014.8 7.97c0-.308.235-.566.543-.598h2.05V5.34a.604.604 0 01.604-.54c.31 0 .57.234.602.54V7.37h2.057c.31.032.544.29.544.598a.603.603 0 01-.544.597z","fill":"#0084F3"}})])
          )
        }
      }
    